import { SettingsSaveDataSLA } from "./acd";
import { Attachment } from "./attachment";

export type SendParams =
  | SendAssignCases
  | SendAddNote
  | SendChangeGroup
  | SendClaimCases
  | SendClaimSingleCase
  | SendCloseCases
  | SendCloseSingleCase
  | SendCreateAcd
  | SendEmail
  | SendReclassifyCases
  | ResendToStudioCases
  | SendSetCaseId
  | SendSetSpamStatus
  | SendUnclaimCase

type SendAssignCases = {
  type: "AssignCases";
  payload: {
    userId: number;
    caseReferences: string[];
  };
};

type SendAddNote = {
  type: "AddNote";
  payload: {
    note: string;
    requestId: string;
    caseReference: string;
  };
};

type SendClaimCases = {
  type: "ClaimCases";
  payload: string[];
};

type SendClaimSingleCase = {
  type: "ClaimCase";
  payload: string;
};

type SendCloseCases = {
  type: "CloseCases";
  payload: {
    clientId: number;
    caseReferences: string[];
  };
};

type SendCloseSingleCase = {
  type: "CloseCase";
  payload: {
    clientId: number|null;
    caseReference: string;
  };
};

type SendCreateAcd = {
  type: "CreateAcd";
  payload: {
    amberThresholdHours: number;
    clientCode: string;
    clientId?: number;
    clientName: string;
    slaHours: number;
    slas: SettingsSaveDataSLA[];
  }
};

type SendEmail = {
  type: "SendEmail",
  payload: OutboundEmail,
};

type SendReclassifyCases = {
  type: "ReclassifyCases";
  payload: {
    caseReferences: string[];
    classificationId: string;
  };
};

type ResendToStudioCases = {
  type: "ResendToStudioCases";
  payload: {
    caseReferences: string[];
    groupId?: number;
  };
};

type SendChangeGroup = {
  type: "ChangeGroup";
  payload: {
    caseReference: string;
    groupId: number;
  };
};

type SendSetCaseId = {
  type: "SetCaseAcd";
  payload: {
    caseReference: string;
    acdId: string;
  };
};

type SendSetSpamStatus = {
  type: "SetSpamStatus";
  payload: {
    caseReference: string;
    spamStatus: SpamStatus;
    sendAcknowledgement: boolean;
    data?: EmailRulesData
  }
};

type SendUnclaimCase = {
  type: "UnclaimCase";
  payload: string;
};

export type OutboundEmail = {
  requestId: string;
  toAddresses: string;
  ccAddress: string;
  fromAddress: string;
  subject: string;
  body: string;
  caseReference: string;
  includeCaseHistory: boolean;
  messageId: string;
  attachments: Attachment[];
}

export type EmailRulesData = {
  emailAddress: string;
  classificationId: number|null;
  clientId: number|null;
  suppressAutoResponse: boolean;
  autoClose: boolean;
};

export enum SpamStatus {
  spam = "Spam",
  notSpam = "NotSpam",
  potentialSpam = "PotentialSpam",
}
